import { Component } from '@angular/core';

@Component({
    selector: 'plan-switch',
    styleUrls: ['./landing.scss'],
    templateUrl: './landing.html',
    standalone: false
})
export class PlanSwitchComponent {}
